export default "__VITE_ASSET__DEYs$BlQ__"